import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3.552a8.448 8.448 0 1 1 0 16.896 8.448 8.448 0 0 1 0-16.896m0 18.396c5.494 0 9.948-4.454 9.948-9.948S17.494 2.052 12 2.052 2.052 6.506 2.052 12 6.506 21.948 12 21.948m3.514-12.375a.75.75 0 0 0-1.06 0l-3.264 3.263-1.643-1.642a.75.75 0 0 0-1.06 1.061l2.172 2.172a.75.75 0 0 0 1.06 0l3.795-3.794a.75.75 0 0 0 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }